import { PushReferrersToInviteMoreFriendsDialog } from '@colonist/clientforge';
import { ReferralProgram } from '../../../../shared/ReferralProgram.ts';
import { mountDialogUIReactComponent } from '../../../shared/scripts/ui_platform/mountDialogUIReactComponent.tsx';
import { navigateToPage } from '../../../shared/scripts/ui_utils/ClientUtils.ts';
const renderPushReferrersToInviteMoreFriendsDialog = mountDialogUIReactComponent(PushReferrersToInviteMoreFriendsDialog);
export function showPushReferrersToInviteMoreFriendsDialog(referralCount) {
    const remainingReferrals = ReferralProgram.referralRewardLevels[1].referralCount - referralCount;
    renderPushReferrersToInviteMoreFriendsDialog({
        remainingReferrals: remainingReferrals,
        onClaimMap: ()=>{
            navigateToPage('/store#referrals=showpopup');
        }
    });
}
